import axios, { AxiosInstance } from "axios"

/** Axios-instanssi BIM-vertailukaareelle (`vahti_ifc/bim_api.py`).
 *
 *  Erillaan `http-common.ts`:sta kahdesta syysta: kaare on eri palvelu eri
 *  portissa, eika sille lahetetä Auth0-tokenia — se ei autentikoi pyyntoja
 *  (tietoinen PoC-rajaus, palvelu kuuntelee vain 127.0.0.1:ta). Auth0-token
 *  vuotaisi turhaan palvelulle joka ei sita tarvitse.
 *
 *  Timeout on lyhyt tarkoituksella: jos kaare ei ole pystyssa, BIM-liitospinnat
 *  piiloutuvat hiljaa eivatka jumita Vahdin nakymia.
 */
const bimClient: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_BIM_API_URL,
    timeout: 20000,
    headers: {
        "Content-type": "application/json",
    },
})

/** Onko BIM-liitos ylipaataan konfiguroitu tahan ymparistoon.
 *  Ilman ymparistomuuttujaa mitaan ei kysella eika mitaan nayteta. */
export const bimKaytossa = !!process.env.VUE_APP_BIM_API_URL

/** Upotetun katselimen osoite. Devissa erillinen Vite-palvelin, demossa
 *  `/bim/` samasta originista (`npm run build:vahti`).
 *
 *  `||` eika `??`: Dockerfilen ARG-oletus antaa muuttujalle TYHJAN
 *  merkkijonon, joka ei ole nullish. `??` jattaisi osoitteeksi "", jolloin
 *  new URL("", location.href) osoittaa Vahtiin itseensa ja "Avaa malli"
 *  avaisi toisen Vahti-ikkunan katselimen sijaan (mitattu buildista). */
export const bimKatselinUrl = process.env.VUE_APP_BIM_VIEWER_URL || "/bim/"

export default bimClient
